//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  defineComponent,
  reactive,
  computed,
  watchEffect,
  toRefs,
  ref,
  useContext,
} from '@nuxtjs/composition-api'
import { useValidation, ruleLib } from '../plugins/validate'
import { useAlter } from '../plugins/alter'
import { post } from '~/helpers/fetch'
function useExtraFields(extraFields) {
  const extra = {}
  const extraRules = {}
  for (let i = 0; i < extraFields.length; i++) {
    const el = extraFields[i]
    extra[el.name] = ''
    if (el.required) {
      extraRules[el.name] = [
        (v) => (!v ? el.err || 'Du musst ein Element auswählen!' : true),
      ]
    }
  }
  return {
    extraData: extra,
    extraRules,
  }
}
function useData(extra) {
  const data = reactive({
    vorname: '',
    nachname: '',
    gebDat: '',
    geschlecht: '',
    strasse: '',
    plzOrt: {
      plz: '',
      ort: '',
    },
    email: '',
    telefon: '',
    vegetarisch: false,
    lebensmittelallergien: '',
    bemerkungen: '',
    gesundheit: '',
    klettern: false,
    bootfahren: false,
    schwimmen: 0,
    fahrrad: false,
    sichEntfernen: false,
    datenschutz: false,
    tnBedingungen: false,
    freizeitLeitung: false,
    fahrgemeinschaften: false,
    extra,
  })
  return { data }
}
function handleFreizeitleitung(data, props) {
  let oldHatFreizeitleitung = null
  watchEffect(() => {
    if (oldHatFreizeitleitung !== props.hatFreizeitleitung) {
      data.freizeitLeitung = !props.hatFreizeitleitung
      oldHatFreizeitleitung = props.hatFreizeitleitung
    }
  })
}
export default defineComponent({
  props: {
    hatEssen: Boolean,
    hatGesundheit: Boolean,
    hatErlaubnisBoot: Boolean,
    hatErlaubnisKlettern: Boolean,
    hatErlaubnisFahrrad: Boolean,
    hatErlaubnisSchwimmen: Boolean,
    hatErlaubnisSichEntfernen: Boolean,
    hatFahrgemeinschaft: Boolean,
    hatFreizeitleitung: Boolean,
    veranstaltungsBegin: {
      type: String,
      required: true,
    },
    minAlter: {
      type: Number,
      default: -1,
    },
    maxAlter: {
      type: Number,
      default: 999,
    },
    extraFields: {
      type: Array,
      default: () => [],
    },
    veranstaltungsID: {
      type: Number,
      required: true,
    },
    jahrgangMin: {
      type: Number,
      default: 1900,
    },
    jahrgangMax: {
      type: Number,
      default: 2100,
    },
    disabled: Boolean,
    startAt: String,
  },
  setup(props) {
    const hatErlaubnisse = computed(
      () =>
        props.hatErlaubnisBoot ||
        props.hatErlaubnisKlettern ||
        props.hatErlaubnisFahrrad ||
        props.hatErlaubnisSchwimmen ||
        props.hatErlaubnisSichEntfernen
    )
    const sending = ref(false)
    const success = ref(false)
    const error = ref(null) // as null | string[] | string)
    const { extraData, extraRules } = useExtraFields(props.extraFields)
    const { data } = useData(extraData)
    handleFreizeitleitung(data, props)
    const submit = async () => {
      sending.value = true
      const submitData = {
        vorname: data.vorname,
        nachname: data.nachname,
        gebDat: data.gebDat,
        geschlecht: data.geschlecht,
        strasse: data.strasse,
        plz: data.plzOrt.plz,
        ort: data.plzOrt.ort,
        email: data.email,
        telefon: data.telefon,
        vegetarisch: data.vegetarisch,
        lebensmittelallergien: data.lebensmittelallergien,
        bemerkungen: data.bemerkungen,
        gesundheit: data.gesundheit,
        klettern: data.klettern,
        bootfahren: data.bootfahren,
        schwimmen: data.schwimmen,
        fahrrad: data.fahrrad,
        sichEntfernen: data.sichEntfernen,
        fahrgemeinschaften: data.fahrgemeinschaften,
        extra: data.extra,
        datenschutz: data.datenschutz,
        freizeitLeitung: data.freizeitLeitung,
        tnBedingungen: data.tnBedingungen,
        fahrgemeinschaften: data.fahrgemeinschaften,
        alter: alterData.falschesAlter.value,
      }
      try {
        const ret = await post(
          '/anmeldung/tn/' + props.veranstaltungsID,
          submitData
        )
        if (ret.status !== 'OK') {
          error.value = ret.context
        } else {
          error.value = null
          success.value = true
        }
        // console.log('testANMELDUNG1', ret)
      } catch (e) {
        error.value = e
        // console.log('testANMELDUNG_FEHLER_2')
      }
      sending.value = false
    }
    const validation = useValidation(
      data,
      {
        vorname: ruleLib.vorname,
        nachname: ruleLib.nachname,
        geschlecht: ruleLib.geschlecht,
        gebDat: ruleLib.gebDat,
        strasse: ruleLib.strasse,
        plzOrt: {
          plz: ruleLib.plz,
          ort: ruleLib.ort,
        },
        email: ruleLib.email,
        telefon: ruleLib.telefon,
        bemerkungen: ruleLib.textArea250,
        lebensmittelallergien: ruleLib.textArea250,
        gesundheit: ruleLib.textArea250,
        datenschutz: ruleLib.datenschutz,
        freizeitLeitung: ruleLib.checkboxRequired,
        tnBedingungen: ruleLib.tnBedingungen,
        extra: extraRules,
      },
      [
        'vorname',
        'nachname',
        'geschlecht',
        'gebDat',
        'strasse',
        'email',
        'datenschutz',
        'telefon',
        'tnBedingungen',
        'freizeitLeitung',
        'lebensmittelallergien',
        'bemerkungen',
        'gesundheit',
      ]
    )
    const { alter, under18 } = useAlter(
      toRefs(data).gebDat,
      props.veranstaltungsBegin
    )
    const alterData = {
      under18,
      zuJung: computed(
        () =>
          alter.value < props.minAlter ||
          (data.gebDat &&
            parseInt(data.gebDat.split('-')[0]) > props.jahrgangMax)
      ),
      zuAlt: computed(
        () =>
          alter.value > props.maxAlter ||
          (data.gebDat &&
            parseInt(data.gebDat.split('-')[0]) < props.jahrgangMin)
      ),
      falschesAlter: computed(
        () => !(alterData.zuJung.value || alterData.zuAlt.value)
      ),
    }
    return {
      ...validation.rootMapper,
      ...alterData,
      ...validation,
      // disabled: props.disabled,
      // startAt: props.startAt,
      forceValidate: () => {
        Object.keys(validation.rootMapper).forEach((key) => {
          if (typeof validation.rootMapper[key] === 'function') {
            validation.rootMapper[key]()
          }
        })
      },
      data,
      submit,
      hatErlaubnisse,
      countdown: new Date().getTime() < new Date(props.startAt).getTime(),
      sending,
      success,
      error,
      force: !!useContext().query.value.anmeldung,
      reload: () => location.reload(),
    }
  },
})
